import { createSelector } from '@ngrx/store';

import { getMenuFlowDetailsSepcificPageByWizzard } from '../getMenuFlowDetailsSepcificPageByWizzard';

export const isWizzardPageOneAllowed = (pageIdentifier: number) =>
    createSelector(getMenuFlowDetailsSepcificPageByWizzard(pageIdentifier), (pageDetails) => (pageDetails ? pageDetails.PageMaxQuantity === 1 : null));
